import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.PayWithAmax.PaymentCanceledPopup', {
    learnMore: 'Learn more',
    unableToConfirm: 'Unable to confirm the payment',
    thereWasAnIssue: 'Oops, there was an issue confirming the payment.',
    retry: 'Try again',
});
